/* eslint react/prop-types: 0 */
import React from 'react';
import { formatMoney } from '../../../utils/money';
import { HorseLink } from '../../../shared/links/ProfileLink';
import HorseCell from '../components/HorseCell';
import Abbr from '../../../shared/Abbr';
import { numericAndDashSort } from '../../../utils/number';

const columns = [
    {
        key: 'horseName',
        header: () => (
            <Abbr title="horse">
                horse / dam&apos;s sire
            </Abbr>
        ),
        cell: data => <HorseCell {...data} isDamSire />,
        sortFn: 'alphabetic',
    },
    {
        key: 'damSireStyleName',
        header: 'dam\'s sire',
        cell: ({ damSireStyleName, damSireUid, damSireCountryOriginCode }) => (
            <span>
                <HorseLink
                    className="ui-link_marked"
                    horseStyleName={damSireStyleName}
                    horseUid={damSireUid}
                />
                <span>{` (${damSireCountryOriginCode})`}</span>
            </span>
        ),
        sortFn: 'alphabetic',
    },
    {
        key: 'wins',
        header: () => (
            <Abbr title="wins">
                wins / runs
            </Abbr>
        ),
        cell: ({ wins, runs }) => (
            <span>
                <strong>{wins}</strong>
                <span className="hidden-sm-up">/{runs}</span>
            </span>
        ),
    },
    {
        key: 'runs',
    },
    {
        key: 'winPercent',
        header: '%',
    },
    {
        key: 'places',
        header: 'placed',
    },
    {
        key: 'totalPrizeMoney',
        header: 'total earnings',
        cell: ({ totalPrizeMoney }) => formatMoney(totalPrizeMoney),
        sortFn: numericAndDashSort('totalPrizeMoney'),
    },
    {
        key: 'bestOr',
        header: 'best or',
        sortFn: numericAndDashSort('bestOr'),
    },
    {
        key: 'rpPostmark',
        header: 'best rpr',
        sortFn: numericAndDashSort('rpPostmark'),
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/progeny/sire/columns.jsx